import config from "../config";
export default function Footer() {
  return (
    <footer>
      <div className="footerBlock">
        <div>
          <img src="img/gc.svg" alt="icon" />
          <img src="img/18.svg" alt="icon" />
        </div>
        <p>© 2025 {config.brandName} Casino</p>
      </div>
    </footer>
  );
}
